export default "__VITE_ASSET__DPK_K3AN__"